import colors from "colors";
import { IconProps } from "./types";

export default function IcoFileEdit({
	color = colors.neutral["low-pure-500"],
	size = "24"
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.5 3C3.5 2.72386 3.72386 2.5 4 2.5H14.5858C14.7184 2.5 14.8456 2.55268 14.9393 2.64645L18.3536 6.06066C18.4473 6.15443 18.5 6.28161 18.5 6.41421V8.5C18.5 8.77614 18.7239 9 19 9C19.2761 9 19.5 8.77614 19.5 8.5V6.41421C19.5 6.01639 19.342 5.63486 19.0607 5.35355L15.6464 1.93934C15.3651 1.65803 14.9836 1.5 14.5858 1.5H4C3.17157 1.5 2.5 2.17157 2.5 3V21C2.5 21.8284 3.17157 22.5 4 22.5H8C8.27614 22.5 8.5 22.2761 8.5 22C8.5 21.7239 8.27614 21.5 8 21.5H4C3.72386 21.5 3.5 21.2761 3.5 21V3Z"
				fill={color}
			/>
			<path
				d="M7.39868 5.94409C7.12254 5.94409 6.89868 6.16795 6.89868 6.44409C6.89868 6.72023 7.12254 6.94409 7.39868 6.94409H11.2474C11.5236 6.94409 11.7474 6.72023 11.7474 6.44409C11.7474 6.16795 11.5236 5.94409 11.2474 5.94409H7.39868Z"
				fill={color}
			/>
			<path
				d="M6.89868 9.77734C6.89868 9.5012 7.12254 9.27734 7.39868 9.27734H13.9965C14.2727 9.27734 14.4965 9.5012 14.4965 9.77734C14.4965 10.0535 14.2727 10.2773 13.9965 10.2773H7.39868C7.12254 10.2773 6.89868 10.0535 6.89868 9.77734Z"
				fill={color}
			/>
			<path
				d="M7.39868 12.6108C7.12254 12.6108 6.89868 12.8347 6.89868 13.1108C6.89868 13.387 7.12254 13.6108 7.39868 13.6108H12C12.2761 13.6108 12.5 13.387 12.5 13.1108C12.5 12.8347 12.2761 12.6108 12 12.6108H7.39868Z"
				fill={color}
			/>
			<path
				d="M6.89868 16.4443C6.89868 16.1682 7.12254 15.9443 7.39868 15.9443H9C9.27614 15.9443 9.5 16.1682 9.5 16.4443C9.5 16.7205 9.27614 16.9443 9 16.9443H7.39868C7.12254 16.9443 6.89868 16.7205 6.89868 16.4443Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.5965 12.1687C18.0246 11.7405 18.6053 11.5 19.2108 11.5C19.8163 11.5 20.397 11.7405 20.8252 12.1687C21.2497 12.5946 21.5 13.1812 21.5 13.7894C21.5 14.3942 21.2603 14.9743 20.8334 15.4027L14.4887 21.7466C14.3608 21.8739 14.1985 21.9611 14.0217 21.9975L14.0189 21.9981L11.6018 22.4811C11.4532 22.5107 11.2991 22.5033 11.1541 22.4593C11.009 22.4153 10.8771 22.3362 10.7699 22.229C10.6627 22.1218 10.5836 21.9899 10.5397 21.8448C10.4957 21.6998 10.4881 21.5461 10.5177 21.3975L11.0014 18.9789C11.0378 18.8022 11.125 18.6399 11.2523 18.512L17.5965 12.1687ZM19.2108 12.5C18.8705 12.5 18.5442 12.6352 18.3035 12.8758L11.9767 19.2018L11.5216 21.4774L13.7988 21.0223L20.1251 14.6968C20.365 14.4559 20.5 14.1294 20.5 13.7894C20.5 13.4527 20.3601 13.1189 20.1178 12.8755C19.8772 12.6351 19.551 12.5 19.2108 12.5Z"
				fill={color}
			/>
		</svg>
	);
}
